<template>
    <!-- Employees Business Profile -->
    <div class="page-layout blank contacts-manage">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                </div>
            </div>
        </div>
        <div class="pb-10 pr-3 ml-1" v-if="!ajaxCallinprogress && company_details!=null">
            <!-- <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <div class="breadcrumbnew">
                        <span @click="$router.go(-1)">Company Profile</span>
                        <span>Company Info</span>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                </div>
            </div> -->
            <!-- </h2> -->
            <div class="profile-block">
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block" style="border-radius: 15px;overflow: auto;">
                    <!-- <div class="left-side-div">
                        <div class="digi-sidebar digi-left-positioned digi-open digi-locked-open">
                            <div class="cover-card">
                                <img class="cover-card-img-top w-full" :src="company_details.cover_image || userProfile" alt="Cover Pic" style="height: 180px;">
                                <div class="cover-card-block wall-person-info">
                                    <a class="person-avatar bg-white pro-img-bordered">
                                        <img class="businesslogoimg" :src="company_details.logo || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                                    </a>
                                </div>
                            </div>
                            <div class="digi-content-block px-4 py-2 mt-10">
                                <div class="header pt-4">
                                    <div class="contactInfo">
                                        <div>
                                            <div class="d-flex text-white justify-content-center fw-600 fs-14 pt-3 pb-8">
                                                <img src="https://storage.googleapis.com/5f224c2c816cc1fff0e4f41f/68cf7fed-9667-4cc0-8553-5e6018ad3966.jpeg" alt="DigiColllect CRM Admin ii" class="profileImg" style="width: 60px; height: 60px; border-radius: 50%; border: 1px solid white;">
                                                <span class="ml-2">
                                                    <div class="fw-700">
                                                        Business Profile
                                                    </div>
                                                    <div class=" mt-3 fw-700">
                                                        {{company_details.name}}
                                                    </div>
                                                </span>
                                            </div> -->
                                            <!-- <div class="d-flex justify-content-center" style="cursor: pointer; box-shadow: none; border-radius: 5px; border: 0.5px solid rgb(30, 171, 229); background-color: rgb(41, 194, 224);">
                                                <div class="py-3 mx-1">
                                                    <div class="connection_details">
                                                        <div class="count h2 text-white mb-1" style="line-height: 1.19; font-size: 16px;">0</div>
                                                        <div class="text-white" style="line-height: 1.19; font-size: 14px;">
                                                            Connections
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="mx-1 my-2" style="border-right: 1px solid rgb(4, 117, 243); height: 55px;"></span>
                                                <div class="py-3 mx-1">
                                                    <div class="connection_details">
                                                        <div class="count h2 text-white mb-1" style="line-height: 1.19; font-size: 16px;">0</div>
                                                        <div class="text-white" style="line-height: 1.19; font-size: 14px;">Followers</div>
                                                    </div>
                                                </div>
                                                <span class="mx-1 my-2" style="border-right: 1px solid rgb(4, 117, 243); height: 55px;"></span>
                                                <div class="py-3 ml-3 mr-3">
                                                    <div class="connection_details">
                                                        <div class="count h2 text-white mb-1" style="line-height: 1.19; font-size: 16px;">0</div>
                                                        <div class="text-white" style="line-height: 1.19; font-size: 14px;">
                                                            Following
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                        <!-- </div> -->
                                        <!-- <div class="profile-list business-list-info">
                                            <div style="width: 100%;" class="qrcode-whole-div">
                                                <div class="qrcode-block-view mt-6">
                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/qr-logo-dg.svg" class="qr-logo-view">
                                                    <qrcode-vue value="Hello" level="H" background="#fff" foreground="#005dae" class="qrcode-content-view"></qrcode-vue>
                                                </div>
                                            </div>
                                        </div>
                                        <h5 class="fs-16 pt-4 pb-3 text-center text-white fw-600">Scan Code</h5> -->
                                    <!-- </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="center-section pt-5" style="background-color: transparent !important; border: none !important;" >
                        <div class="w-100" style="overflow: hidden">
                            <div class="center-content">
                                <div class="cover-card">
                                    <img class="cover-card-img-top w-full" :src="company_details.cover_image || userProfile" alt="Cover Pic" style="height: 180px; width: 400px">
                                    <div class="cover-card-block wall-person-info">
                                        <a class="person-avatar bg-white pro-img-bordered">
                                            <img class="businesslogoimg" :src="company_details.logo || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                                        </a>
                                    </div>
                                </div>
                                <div class="digi-content-block px-4 py-2 mt-10">
                                    <div class="header pt-4">
                                        <div class="contactInfo">
                                            <div>
                                                <div class="d-flex text-white justify-content-center fw-600 fs-14">
                                                    <img src="https://storage.googleapis.com/5f224c2c816cc1fff0e4f41f/68cf7fed-9667-4cc0-8553-5e6018ad3966.jpeg" alt="DigiColllect CRM Admin ii" class="profileImg" style="width: 60px; height: 60px; border-radius: 50%; border: 1px solid white;">
                                                    <span class="ml-2">
                                                        <div class="mt-2 fw-700 text-blue">
                                                            Business Profile
                                                        </div>
                                                        <div class="mt-2 fw-700 text-blue">
                                                            {{company_details.name}}
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="d-flex align-items-center">
                                    <div class="pw-600 slant-tabs d-flex align-items-center justify-content-center activeTab new-blue pt-2">
                                       Company Info
                                    </div>
                                </div> -->
                                <div class="center-content" style="background-color: rgb(255, 255, 255) !important;">
                                    <div class="preview-elements">
                                        <div id="myTabContent" class="tab-content profile-tab-content scroll-media">
                                            <div id="basictab" aria-labelledby="basic-tab">
                                                <div>
                                                    <div class="tabs-content-secondblock">
                                                        <div class="header-outer mt-4">
                                                            <span class="fw-500">Company Information</span>
                                                            <span class="pointer" @click="showBasicInformation">
                                                                <i v-if="show_basic_info" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                                                                <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                                                            </span>
                                                        </div>
                                                        <div v-if="show_basic_info" class="p-6">
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Company Name</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.name">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Industry Type</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.industry_type">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Domain Name</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.domain">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Date of Incorporation</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.date_of_incorporation">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Number of Employees</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.no_of_employees">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Time Zone</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.time_zone">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Currency</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly :value="company_details.currency.label">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Tax ID</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.tax_id">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">About</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.about">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="header-outer mt-4">
                                                            <span class="fw-500">Fiscal Year</span>
                                                            <span class="pointer" @click="showFiscalYear">
                                                                <i v-if="show_fiscal_year" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                                                                <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                                                            </span>
                                                        </div>
                                                        <div v-if="show_fiscal_year" class="p-6">
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Fiscal Year Name</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.fiscal_year_name">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="mt-5">
                                                                        <div class="d-flex align-items-center new-contactView ">
                                                                            <div class="col-3">
                                                                                <div class="fs-14 fw-600 text-secondary profile-content-left-text">Start Date</div>
                                                                            </div>
                                                                            <div class="w-100 col-9">
                                                                                <input name='title' class="input-field-underline" style="padding-top: 6px !important;" readonly v-model="company_details.start_date">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { HalfCircleSpinner } from 'epic-spinners';
import crm from "./mixins/crm"
export default {
    data() {
        return {
            ajaxCallinprogress: false,
            userProfile: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
            company_details: null,
            show_basic_info: true,
            show_fiscal_year: true
        };
    },
    mixins:[crm],
    components: {
        HalfCircleSpinner,
        QrcodeVue
    },
    methods: {
        showBasicInformation() {
            this.show_basic_info = !this.show_basic_info
        },
        showFiscalYear() {
            this.show_fiscal_year = !this.show_fiscal_year
        },
        async loadCompanyDetails(){
            this.ajaxCallinprogress = true
            let response = await this.getCompanyDetails(this.loggedInUser.company_id)
            this.company_details = response.response
            this.ajaxCallinprogress = false
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        account() {
            return this.$store.getters.account;
        },
        admin() {
            return this.$store.getters.isAdmin;
        },
        superAdmin() {
            return this.$store.getters.isSuperAdmin;
        },
    },
    created() {
        setTimeout(() => {
            this.loadCompanyDetails();
        }, 500);

    },
};
</script>
<style>
    .profile-block {
        /* border: 1px solid #e0e3e6; */
        border-radius: 15px;
        /* margin: 15px 15px 30px; */
        width: 100%;
        /* background: #eaeaec; */
    }

    .page-layout-new {
        position: relative;
        overflow: hidden;
    }

    .page-layout-new.simple-new {
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        width: 100%;
        min-width: 100%;
        border-radius: 15px 15px 15px 15px;
        color: #fff;
        /* border: 1px solid #00448b; */
    }

    /* background-image: linear-gradient(180deg,#eaeaec,#f7f7f8 15%,#f7f7f8 34%,#fff 48%,#f7f7f8 62%,#f7f7f8 85%,hsla(240,5%,92%,.8)); */
    .page-layout-new.simple-new.left-sidebar-block,
    .page-layout-new.simple-new.right-sidebar-block {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        flex-direction: row;
    }

    .page-layout-new.simple-new.left-sidebar-block>.left-side-div,
    .page-layout-new.simple-new.right-sidebar-block>.right-side-div {
        /* background: 0 0; */
        background: transparent;
        box-shadow: none;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar {
        width: 240px;
        min-width: 240px;
        max-width: 240px;
        overflow: hidden;
    }

    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar {
        -webkit-box-ordinal-group: 3;
        order: 2;
    }

    .digi-sidebar {
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        position: absolute;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        width: 350px !important;
        min-width: 350px !important;
        max-width: 350px !important;
    }

    .digi-sidebar.digi-left-positioned {
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        border: solid 0.5px #005dae;
        background-color: #005dae !important;
        border-radius: 15px;
    }

    .digi-sidebar.digi-right-positioned {
        right: 0;
        -webkit-transform: translateX(100%);
        transform: translateX(100%);
    }

    .digi-sidebar.digi-open {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }

    .digi-sidebar.digi-locked-open {
        position: relative !important;
        -webkit-transform: translateX(0) !important;
        transform: translateX(0) !important;
        height: 100%;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar .digi-content-block,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar .digi-content-block {
        -webkit-box-flex: 1;
        flex: 1 1 auto;
    }

    .page-layout-new.simple-new.left-sidebar-block>.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.center-section {
        position: relative;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-flex: 1;
        flex: 1 1 auto;
        z-index: 3;
        min-width: 0;
        width: 100%;
        /* padding: 6px; */
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar.digi-locked-open+.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar.digi-locked-open+.center-section {
        z-index: 1001;
    }

    .page-layout-new.simple-new.left-sidebar-block>.digi-sidebar.digi-locked-open.digi-left-positioned+.center-section,
    .page-layout-new.simple-new.right-sidebar-block>.digi-sidebar.digi-locked-open.digi-left-positioned+.center-section {
        margin-left: 0;
    }

    .page-layout-new.simple-new.left-sidebar-block>.center-section>.center-content,
    .page-layout-new.simple-new.right-sidebar-block>.center-section>.center-content {
        -webkit-box-flex: 1;
        flex: 1 0 auto;
        color: #303031;
    }

    @-moz-document url-prefix() {
        .coverPicIcon {
            margin-top: 123px;
        }

        .mediaIcon {
            top: 19% !important;
        }
    }

    .contactInfo {
        margin-top: 0px;
        display: block;
        justify-content: center;
        align-items: center;
        margin-bottom: 0%;
        position: relative;
        color: #00448b;
    }

    .companyBackground {
        border-right: solid 1px #94bef0;
        background-image: linear-gradient(to bottom,
                #eaeaec,
                #f7f7f8 15%,
                #ffffff 34%,
                #ffffff 48%,
                #ffffff 62%,
                #f7f7f8 85%,
                rgba(234, 234, 236, 0.8));
    }

    .CompanyContact {
        width: 14.2px;
        height: 10.8px;
    }

    .headerTitleView {
        width: 357px;
        height: 40px;
        border-radius: 100px;
        background-color: #f2f2f2;
        margin-top: 15px;
        display: inline-block;
    }

    .contactActiveTab {
        color: #00448b !important;
        border-top: 18px solid transparent;
        border-bottom: 18px solid transparent;
        border-right: solid 18px #cdd2da;
        background-color: #f1f1f1;
        border-right-color: #ffffff;
        overflow: inherit !important;
        padding-left: 45px !important;
    }

    .info:hover {
        color: #00448b;
    }

    .info {
        margin-right: 40px;
    }

    .a-q-Jc-Pj-Ya-contactView {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        line-height: 30px;
    }

    .a-q-Jc-Pj-Ya-contactView {
        line-height: 25px;
        padding: 16px 10px 16px 3px;
        /* border-bottom: solid 1px #707070; */
    }

    .a-q-Jc-bj-contactView {
        -webkit-flex: 0 0 250px;
        flex: 0 0 250px;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #00448b;
        margin-left: 0px;
    }

    .a-q-Jc-Lb-contactView {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-decoration: none;
        line-height: 1.21;
        letter-spacing: normal;
        color: #303031;
        margin-left: 88px;
    }

    .a-q-Jc-Pj-Ya-contactView:nth-of-type(even) {
        background-color: #f5f6f9;
    }

    .a-q-Jc-Lb-contactView.linkactive {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: right;
        color: #00448b;
    }

    .a-q-Jc-wg-contactView {
        text-decoration: none;
    }

    .suggestionCompany {
        width: 48px;
        height: 48px;
    }

    @media screen and (max-width: 991px) {
        .suggestions {
            display: none !important;
        }
    }

    @media screen and (max-width: 764px) {
        .companyDisplay {
            display: none !important;
        }
    }

    .textWhite {
        color: white;
    }

    .contactMediaView {
        font-size: 18px !important;
        padding-top: 3px !important;
        cursor: pointer;
        padding-left: 3px;
    }

    .mediaFacebook:hover {
        color: RGB(0, 132, 255) !important;
    }

    .mediaTwitter:hover {
        color: #1da1f2 !important;
    }

    .mediaLinkedIn:hover {
        color: #0077b5 !important;
    }

    .mediaSkype:hover {
        color: #0077b5 !important;
    }

    .verticalTab {
        height: 41px;
        display: flex;
        width: 100%;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 24px;
        position: relative;
        justify-content: center;
    }

    .contactSidebar {
        overflow-x: hidden;
        width: 312.7px;
        /* border-right: solid 1px #cdd2da; */
        background-image: linear-gradient(to bottom,
                #eaeaec,
                #f7f7f8 15%,
                #ffffff 34%,
                #ffffff 48%,
                #ffffff 62%,
                #f7f7f8 85%,
                rgba(234, 234, 236, 0.8));
    }

    .contactTitle {
        text-align: center;
        display: block;
        color: #fff;
    }

    .elTab {
        overflow-x: hidden !important;
    }

    .editProfile {
        float: right;
        right: 25px;
        top: 135px;
        position: absolute;
        color: #ffffff;
        border-radius: 50px;
        width: 112.5px;
        height: 33.2px;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(0, 0, 0, 0.2);
    }

    .activityContact {
        width: 35px;
        height: 20px;
    }

    .contact-details-tab-view.el-tabs--border-card>.el-tabs__header {
        background-color: #fff !important;
        border-right: none !important;
        color: #00448b;
    }

    .contact-details-tab-view .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        border-right-color: #ffffff !important;
        border-left-color: #ffffff !important;
        border-bottom-color: #00448b;
    }

    .contact-details-tab-view .el-tabs--border-card>.el-tabs__header .el-tabs__item {
        color: #00448b !important;
    }

    .contact-details-tab-view .el-tabs__item {
        color: #303031 !important;
    }

    .el-main.contactTabs {
        padding-top: 0px !important;
        padding-left: 6px !important;
        margin-left: -2px;
        border-left: solid 1px #cdd2da;
        padding-right: 20px !important;
        padding-bottom: 20px !important;
    }

    .email-ul.dc-menu--horizontal {
        height: 42px;
        background-color: #f5f6f9;
    }

    .email-ul.dc-menu--horizontal>.dc-menu-item {
        height: 42px !important;
        line-height: 42px !important;
        margin: 0;
    }

    .email-ul .nav-link {
        height: 42px !important;
        /* background-color: #f5f6f9; */
    }

    .email-ul .nav-link:hover {
        background-color: none !important;
    }

    .email-inputs {
        padding-left: 100px;
        padding-right: 100px;
    }

    .aboutHeading {
        display: flex;
        width: 100%;
        padding-top: 8px;
        padding-left: 22px;
    }

    input[type="file"] {
        display: none;
    }

    .el-main.contactTabs {
        padding-top: 0px !important;
        padding-left: 6px !important;
        margin-left: -2px;
        border-left: solid 1px #cdd2da;
        padding-right: 20px !important;
        padding-bottom: 20px !important;
    }

    .contactSidebar {
        border-right: 0px solid #94b3f0 !important;
    }

    .qrcode-whole-div .qrcode-block-view {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #00448b;
        background: #d6e2ef;
        margin: 0 auto;
    }

    .qrcode-content-view {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 15px 5px 5px !important;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content {
        top: 10px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav .el-tabs__active-bar {
        height: 3px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav-scroll {
        padding: 0 8px !important;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header.is-top .el-tabs__nav-wrap .el-tabs__nav .el-tabs__item {
        padding: 2px 20px;
        height: 45px;
        line-height: 45px;
    }

    .nav-tabs.nav-businessprofile .nav-link.active,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link {
        color: #00448b;
        background-color: transparent;
    }

    .nav-tabs.nav-businessprofile .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link:not(.dropdown-toggle):after {
        background-color: transparent !important;
        content: none !important;
    }

    .nav.nav-tabs.nav-businessprofile {
        background: transparent;
        border-radius: 0px 0px 0px 0px;
    }

    .nav-tabs.nav-businessprofile .nav-link.active {
        overflow: visible;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover,
    .nav-tabs.nav-businessprofile .nav-link:focus {
        border-color: #00448b;
        background-color: #00448b;
        color: #fff !important;
    }

    .nav-tabs.nav-businessprofile .nav-link {
        border: 1px solid #4e5764;
        position: relative;
        display: block;
        height: 48px !important;
        margin-right: 10px;
        line-height: 48px;
        border-radius: 12px;
        margin-right: 10px;
        color: #4e5764
    }

    .nav-tabs.nav-businessprofile .nav-link.active,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link {
        border-color: #00448b;
        background-color: #00448b;
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link img {
        display: inline-block;
        text-align: center;
        margin: 8px auto 6px;
    }

    .nav-tabs.nav-businessprofile .nav-link i {
        display: inline-block;
        text-align: center;
        margin: 12px auto 6px;
        font-size: 16px !important;
        width: 42px;
        height: 14px;
        line-height: 14px;
        color: #4e5764;
    }

    .nav-tabs.nav-businessprofile .nav-link.active i,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link i {
        color: #fff !important;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover i,
    .nav-tabs.nav-businessprofile .nav-link:focus i {
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link h6 {
        display: inline-block;
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        color: #303031;
    }

    .nav-tabs.nav-businessprofile .nav-link.active h6,
    .nav-tabs.nav-businessprofile .nav-item.show .nav-link h6 {
        color: #fff;
    }

    .nav-tabs.nav-businessprofile .nav-link:hover h6,
    .nav-tabs.nav-businessprofile .nav-link:focus h6 {
        color: #fff;
    }

    .tab-content.profile-tab-content {
        padding: 0px 0px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        margin: 0 auto;
        width: 100%;
        font-weight: 600;
        font-size: 14px;
    }

    .tabs.tabs-style-iconbox {
        background: rgba(255, 255, 255, 0.4);
    }

    .tabs.tabs-style-iconbox {
        text-align: center;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: flex;
        margin: 0 auto;
        padding: 0;
        max-width: 1200px;
        list-style: none;
        -ms-box-orient: horizontal;
        -ms-box-pack: center;
        -webkit-flex-flow: row wrap;
        -moz-flex-flow: row wrap;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
    }

    .tabs.tabs-style-iconbox li {
        position: relative;
        z-index: 1;
        display: block;
        margin: 0;
        text-align: center;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .tabs.tabs-style-iconbox li.tab-current {
        z-index: 100;
    }

    .tabs.tabs-style-iconbox a {
        position: relative;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2.5;
        text-decoration: none;
        outline: none;
        width: 100%;
    }

    .tabs.tabs-style-iconbox li a {
        overflow: visible;
        padding: 2em 0;
        line-height: 1;
        -webkit-transition: color 0.2s;
        transition: color 0.2s;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        color: #74777b;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        background: #fff;
        box-shadow: -1px 0 0 #fff;
    }

    .tabs.tabs-style-iconbox .icon::before {
        display: block;
        margin: 0 0 0.25em 0;
    }

    .tabs.tabs-style-iconbox a span {
        vertical-align: middle;
        font-size: 0.75em;
    }

    .tabs.tabs-style-iconbox li a span {
        font-weight: 700;
        font-size: 0.7em;
    }

    .tabs.tabs-style-iconbox li.tab-current a::after,
    .nav-tabs .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs .nav-item.show .nav-link:not(.dropdown-toggle):after {
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -10px;
        width: 0;
        height: 0;
        border: solid transparent;
        border-width: 10px;
        border-top-color: #00448b;
        content: "";
        pointer-events: none;
        background-color: transparent !important;
    }

    .cover-card {
        position: relative;
        display: block;
        min-width: 0;
        word-wrap: break-word;
        background-color: transparent;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        border: 1px solid transparent;
        border-radius: 0rem;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        height: 150px;
    }

    .cover-card {
        margin-bottom: 2.143rem;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        text-align: center;
    }

    .cover-card-img-top {
        width: 100%;
        border-radius: 15px;
        vertical-align: middle;
        border-style: none;
    }

    .cover-card-block.wall-person-info {
        position: relative;
        padding: 1.429rem 0rem 0rem 0rem;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        text-align: center;
    }

    .wall-person-info .person-avatar {
        position: relative;
        top: -100px;
        width: 110px;
        height: 110px;
        text-align: center;
        display: inline-block;
        white-space: nowrap;
        vertical-align: bottom;
        border-radius: 1000px;
    }

    .pro-img-bordered {
        padding: 3px;
        border: 1px solid #e0e0e0;
    }

    /* .person-avatar img {
    width: 100%;
    max-width: 100%;
    height: auto;
    border: 0 none;
    border-radius: 1000px;
    margin: 0px auto;
} */

    .person-avatar .businesslogoimg {
        width: 102px;
        max-width: 102px;
        height: 102px;
        border: 0 none;
        border-radius: 1000px;
        margin: 0px auto;
    }

    .profile-list.business-list-info {
        flex-flow: row wrap;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;
        flex: 0 0 auto;
        padding: 15px 0;
        max-height: none !important;
    }

    .profile-list.business-list-info .profile-list-item {
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        place-content: center;
        align-items: center;
        min-width: 120px;
        min-height: 120px;
        width: 120px;
        height: 120px;
        padding: 10px 0;
        margin: 8px 16px;
        border-radius: 8px;
        cursor: pointer;
    }

    .profile-list.business-list-info .profile-list-item .profile-wrapper {
        font-size: 100px !important;
        width: 100px !important;
        height: 100px !important;
        min-width: 100px !important;
        min-height: 100px !important;
        line-height: 82px !important;
        text-align: center;
    }

    .profile-list.business-list-info .profile-list-item img.profile-images {
        font-size: 85px !important;
        width: 85px !important;
        height: 85px !important;
        min-width: 85px !important;
        min-height: 85px !important;
        line-height: 85px !important;
        display: inline-block;
        margin: 0 auto;
    }

    .profile-name {
        padding: 8px 5px 0;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        color: #fff;
    }



    .a-q-Jc-Pj-Ya-editBusinessView {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        line-height: 30px;
    }

    .a-q-Jc-Pj-Ya-editBusinessView {
        line-height: 25px;
        padding: 10px 10px 10px 3px;
        border-bottom: solid 1px transparent;
    }

    .a-q-Jc-bj-editBusinessView {
        -webkit-flex: 0 0 190px;
        flex: 0 0 190px;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #00448b;
        margin-left: 13px;
    }

    .a-q-Jc-Lb-editBusinessView {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        text-decoration: none;
        line-height: 1.21;
        letter-spacing: normal;
        color: #303031;
        margin-left: 88px;
    }

    .a-q-Jc-Pj-Ya-editBusinessView:nth-of-type(even) {
        background-color: #f5f6f9;
    }

    .a-q-Jc-Lb-editBusinessView.linkactive {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: right;
        color: #00448b;
    }

    .a-q-Jc-wg-editBusinessView {
        text-decoration: none;
    }

    .connectionbox {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0;
        margin: 0;
    }

    .connection_pic {
        padding-right: 1rem;
    }

    .connection_pic img {
        width: 25px;
        height: 25px;
    }

    .connection_details {
        line-height: 0;
        text-align: center;
    }

    .connection_details .count {
        display: block;
        font-size: 14px;
        font-weight: 800;
        line-height: 1.5rem;
        -webkit-transition: color .3s ease;
        transition: color .3s ease;
        color: #fff;
    }

    .connection_details .count-title {
        width: 100px;
        margin-top: 1px;
        display: inline-block;
        font-size: 14px;
        line-height: 1rem;
        font-weight: 600;
        color: #fff;
    }
     .tab-paddding{
        padding-right :32px;
    }
    .primary-tag {
        border-radius: 10px;
        font-size: 10px;
        font-weight: 500;
        padding: 2px 10px;
        color: #fff;
        height: max-content;
    }
    .social-media {
        background: #def0f9;
        border-radius: 5px;
        width: 10em;
        height: 10em;
        margin-right: 25px;
        margin-bottom: 30px;
    }
    .add-vendor{
        color: rgba(103, 103, 103, 0.84);
        position: inherit;
        background: #ffffff;
        width: 100%;
        height: 34px;
        line-height: 32px;
        padding-left: 18px;
        z-index: 9999;
        cursor: pointer;
        top: 84%;
        border: solid 1px #cdd2da;
    }
    .new-field-btn{
        color: #fff;
        background-color: #1c61c2;
    }
    .remainder-list{
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px;
        height:100px
    }
    .new-contactView-item {
        padding: 16px 10px 16px 3px !important;
    }

    .new-contactView {
        display: flex;
        align-items: center;
    }

   .input-field-underline {
		border: none !important;
        border-bottom: solid 0.5px #cdd2da !important;
        background-color: #fff;
        padding: 8px 10px;
        width: 100%;
		/* height: 38px; */
    }
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/CompanyProfileNew.vue